<template lang="pug">
    v-container(grid-list-lg)
        edit-dialog(ref="refEditDialog" @save="onSave")
        background-image-edit-dialog(ref="refBackgroundImage" @save="onSaveImage")
        delay-edit-dialog(ref="refDelayEditDialog" @save="onSaveDelay")
        v-overlay(:value="companyTypesFetching || serviceTypesFetching || saving || bgFetching")
            v-progress-circular(indeterminate size="64")
        v-layout(wrap align-top justify-center)
            v-flex(xs12)
                page-title(:title="$t('pages.settings.system.title')" :icon="pageIcons.system")
            v-flex(xs12)
                card-list(:items="companyTypeItems" type="companyType" @new="onNewItem" @edit="onEditItem")
            v-flex(xs12)
                card-list(:items="serviceTypeItems" type="serviceType" @new="onNewItem" @edit="onEditItem")
        v-layout(wrap)
            v-flex(xs12)
                background-image-list(v-model="images" title="Background Login Setting" @change="onImageListChanged"
                    @new="onNewBackground" @toggle="onTogglePublish" @delay="onDelay" @delete="onDeleteImage")
</template>

<script>
import general from "../../mixins/general";
import PageTitle from "../../components/commons/PageTitle";
import { get } from "vuex-pathify";
import EditDialog from "../../components/system/EditDialog";
import crud from "../../mixins/crud";
import CardList from "../../components/system/CardList";
import BackgroundImageList from "../../components/system/BackgroundImageList";
import BackgroundImageEditDialog from "../../components/system/BackgroundImageEditDialog";
import DelayEditDialog from "../../components/system/DelayEditDialog";

export default {
  name: "SystemSetting",
  components: {
    DelayEditDialog,
    BackgroundImageEditDialog,
    BackgroundImageList,
    CardList,
    EditDialog,
    PageTitle
  },
  mixins: [general, crud],
  data() {
    return {
      saving: false,
      bgFetching: false,
      images: []
    };
  },
  computed: {
    companyTypeItems: get("companyType/items"),
    serviceTypeItems: get("serviceType/items")
  },
  methods: {
    onEditItem(item) {
      this.$refs["refEditDialog"].show("edit", item.type, item.data);
    },
    onNewItem(type) {
      this.$refs["refEditDialog"].show("create", type);
    },
    onSave(data) {
      this.saving = true;
      const url =
        data.type === "companyType" ? "company-types" : "service-types";
      this.axios
        .request({
          method: data.mode === "create" ? "post" : "put",
          url: data.mode === "create" ? url : `${url}/${data.id}`,
          data: data.body
        })
        .then(() => {
          this.fetchCompanyTypes(undefined);
          this.fetchServiceTypes(undefined);
        })
        .catch(err => {
          if (data.mode === "create") this.saveErrorHandler(err);
          if (data.mode === "edit") this.updateErrorHandler(err);
        })
        .finally(() => (this.saving = false));
    },
    onSaveImage(data) {
      this.saving = true;
      const url = "background-images";
      this.axios
        .request({
          method: data.mode === "create" ? "post" : "put",
          url: data.mode === "create" ? url : `${url}/${data.id}`,
          data: data.body
        })
        .then(() => {
          this.fetchBackground();
        })
        .catch(err => {
          if (data.mode === "create") this.saveErrorHandler(err);
          if (data.mode === "edit") this.updateErrorHandler(err);
        })
        .finally(() => (this.saving = false));
    },
    onSaveDelay(delay) {
      this.saving = true;
      const url = "delay";
      this.axios
        .request({
          method: "post",
          url,
          data: {
            delay
          }
        })
        .then(() => {
          this.$toasted.success(this.$t("general.saved"));
        })
        .catch(err => {
          if (data.mode === "create") this.saveErrorHandler(err);
          if (data.mode === "edit") this.updateErrorHandler(err);
        })
        .finally(() => (this.saving = false));
    },
    async fetchBackground() {
      this.bgFetching = true;
      return this.axios
        .get(`background-images`)
        .then(({ data: rawData }) => {
          this.images = rawData.data.sort((a, b) => a.sort - b.sort);
        })
        .finally(() => {
          this.bgFetching = false;
        });
    },
    onImageListChanged(data) {
      this.saving = true;
      this.reorder(this.images)
        .then(() => this.fetchBackground())
        .catch(err => this.updateErrorHandler(err))
        .finally(() => (this.saving = false));
    },
    async reorder(images = []) {
      const mapped = images.map(({ id, detail, published }, index) => {
        return {
          id,
          sort: index,
          detail,
          published
        };
      });
      return new Promise((resolve, reject) => {
        this.axios
          .patch(`background-images/reorder`, { data: mapped })
          .then(res => resolve(res.data))
          .catch(err => reject(err));
      });
    },
    onNewBackground() {
      this.$refs["refBackgroundImage"].show("create");
    },
    onTogglePublish(data) {
      this.saving = true;
      const url = "background-images";
      this.axios
        .request({
          method: "put",
          url: `${url}/${data.id}`,
          data: {
            published: !data.published
          }
        })
        .then(() => {
          this.fetchBackground();
        })
        .catch(err => {
          if (data.mode === "create") this.saveErrorHandler(err);
          if (data.mode === "edit") this.updateErrorHandler(err);
        })
        .finally(() => (this.saving = false));
    },
    async onDelay() {
      const delay = await this.axios.get(`delay`).then(res => +res.data.delay);
      this.$refs["refDelayEditDialog"].show(delay);
    },
    async onDeleteImage(image) {
      if (!image.is_default) {
        const yes = await this.$confirm(`${image.detail}`, {
          dialogType: "delete"
        });
        if (yes) {
          this.saving = true;
          await this.axios
            .delete(`background-images/${image.id}`)
            .finally(() => (this.saving = false));
          this.$toasted.success(this.$t("general.deleted"));
          this.fetchBackground();
        }
      }
    }
  },
  mounted() {
    this.fetchCompanyTypes(undefined);
    this.fetchServiceTypes(undefined);
    this.fetchBackground();
  }
};
</script>
